module.exports = __webpack_public_path__ + "static/media/logo配色图-2.b81b9465.png";